import OnyxAIInsights from './OnyxAIInsights'

export default OnyxAIInsights
